import { action } from 'typesafe-actions';

import * as types from './types';

export const fetchHomepage = () => action(types.FETCH_HOMEPAGE);
export const fetchHomepageSuccess = (data: any) => action(types.FETCH_HOMEPAGE_SUCCESS, data);
export const fetchHomepageError = (error: any) => action(types.FETCH_HOMEPAGE_ERROR, error);
